<div class="dashboard-body">
  <div class="row col-md-12 header-row">
    <div class="row col-md-7 pull-left school-name-search-row">
      <mat-form-field
        class="school-name-search-mat-form-field"
        appearance="fill"
      >
        <mat-label>Search for school name</mat-label>
        <input matInput type="text" [(ngModel)]="searchText" />
        <button
          *ngIf="searchText"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="searchText = ''"
        >
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div
      class="col-md-2 col-sm-6 col-xs-10 school-filters-dropdown pull-left"
      *ngIf="schoolFiltersForDropdown"
    >
      <p class="dropdown-header">Filter By</p>
      <ng-select
        #schoolFiltersDropdown
        [items]="schoolFiltersForDropdown"
        bindLabel="text"
        bindValue="id"
        [disabled]="kpiService.loadingSchoolData"
        (change)="showFilter()"
        [(ngModel)]="kpiService.selectedSchoolFilter"
        [clearable]="false"
        [searchable]="false"
        placeholder="- Select a filter -"
        (close)="removeFocusFromDropdown()"
        class="generic-dropdown"
        data-cy="SchoolFilterDropdown"
        *ngIf="schoolFiltersForDropdown.length > 1"
      >
      </ng-select>
    </div>
    <div class="col-md-2 col-sm-6 col-xs-10 school-filters-dropdown pull-left">
      <p class="dropdown-header">&nbsp;</p>
      <ng-select
        #schoolLevelsDropdown
        [items]="schoolLevelsForDropdown"
        bindLabel="text"
        bindValue="id"
        [disabled]="kpiService.loadingSchoolData"
        placeholder="- Select a filter -"
        (change)="filterByLevel()"
        [(ngModel)]="kpiService.selectedSchoolLevel"
        [clearable]="false"
        [searchable]="false"
        (close)="removeFocusFromDropdown()"
        class="generic-dropdown"
        *ngIf="kpiService.selectedSchoolFilter == 'school_level'"
      >
      </ng-select>
      <ng-select
        #schoolRegionsDropdown
        [items]="schoolRegionsForDropdown"
        bindLabel="text"
        bindValue="id"
        [disabled]="kpiService.loadingSchoolData"
        placeholder="- Select a filter -"
        (change)="filterByRegion()"
        [(ngModel)]="kpiService.selectedSchoolRegion"
        [clearable]="false"
        [searchable]="false"
        (close)="removeFocusFromDropdown()"
        class="generic-dropdown"
        *ngIf="kpiService.selectedSchoolFilter == 'school_region'"
      >
      </ng-select>
      <div *ngFor="let demographicCategoryName of demographicCategoryNamesList">
        <ng-select
          #demoDropdown
          [items]="demoCategoriesForDropdown[demographicCategoryName]"
          bindLabel="text"
          [disabled]="kpiService.loadingSchoolData"
          placeholder="- Select a filter -"
          (change)="filterByDemographic(demographicCategoryName)"
          [(ngModel)]="kpiService.selectedSchoolDemographic"
          [clearable]="false"
          [searchable]="false"
          (close)="removeFocusFromDropdown()"
          class="generic-dropdown"
          data-cy="DemoDropdown"
          *ngIf="kpiService.selectedSchoolFilter == demographicCategoryName"
        >
        </ng-select>
      </div>
    </div>
  </div>
  <div class="row col-md-12 table-row">
    <mat-progress-spinner
      *ngIf="kpiService.loadingSchoolData; else tableLoaded"
      class="modal-spinner"
      [diameter]="75"
      [mode]="'indeterminate'"
    >
    </mat-progress-spinner>
    <ng-template #tableLoaded>
      <school-comp-table
        *ngIf="schools && columns && panels && district"
        [panels]="panels"
        [columns]="columns"
        [districtOverall]="districtOverall"
        [district]="district"
        [schools]="schools | appFilter: searchText:'officialSchoolName'"
        [sortCol]="sortCol"
        [sortDirection]="sortDirection"
        [districtColors]="districtColors"
        [initialPageNumber]="kpiService.schoolPageNumber"
        [initialPageSize]="kpiService.schoolPageSize"
        (emitUpdatePagination)="updatePaginationUrlParams($event)"
        (emitSortColumn)="sortColumn($event)"
      >
      </school-comp-table>
    </ng-template>
  </div>
</div>
